import React from "react";

export default function BoxBlock({ title, icon, children, footer, onClick, iconOnClick, className = "px-3 py-3 space-y-4", headerClass = "bg-gray-50 dark:bg-zinc-800", headerOtherClass = "px-3 py-2 flex items-center justify-between", footerClass = "bg-gray-50 dark:bg-zinc-800 py-2 px-2" }) {
    return (
        <div
            onClick={onClick}
            className="
            rounded-2xl bg-white dark:bg-zinc-900 
            shadow-md border border-gray-200 dark:border-zinc-700
            overflow-hidden
      "
        >
            {/* Header */}
            <div className={`${headerClass} ${headerOtherClass}`}>
                {title && (
                    <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">
                        {title}
                    </span>
                )}

                {icon && (
                    <div
                        onClick={(e) => {
                            e.stopPropagation(); // ← NE indítsa el a BoxBlock onClick-et
                            iconOnClick?.(e);    // ← Ha átadtak callbacket, fusson le
                        }}
                        className={`text-gray-500 dark:text-gray-300 ${iconOnClick ? "cursor-pointer" : ""}`}
                    >
                        {React.cloneElement(icon, {
                            className: "w-4 h-4 text-gray-500 dark:text-gray-300"
                        })}
                    </div>
                )}
            </div>

            {/* Body */}
            <div className={`${className}`}>
                {children}
            </div>

            {footer && (
                <div className={`${footerClass}`}>
                    {footer}
                </div>
            )}
        </div>
    );
}